import IpubBreadcrumb from './src/main'

/* istanbul ignore next */
IpubBreadcrumb.install = function(Vue) {
  Vue.component(IpubBreadcrumb.name, IpubBreadcrumb)
}

export default IpubBreadcrumb
